import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FiltersItem } from '../../../../models/shared/filters-item.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-interests-filters-checkbox',
    templateUrl: './interests-filters-checkbox.component.html',
})
export class InterestsFiltersCheckboxComponent implements OnInit {
    @Output() ready = new EventEmitter();
    @Output() selectionChanged = new EventEmitter();

    interestsFilterItem: FiltersItem;

    constructor(private translate: TranslateService) {}

    ngOnInit(): void {
        const msg = this.translate.instant('filters.skillsInterests.myInterests');
        this.interestsFilterItem = new FiltersItem('isMyInterestsChecked', msg);
        this.ready.emit();
    }

    onInterestsSelectionChanged() {
        this.selectionChanged.emit();
    }

    resetFilters(): void {
        this.interestsFilterItem.checked = false;
    }

    onSelectionChanged() {
        this.selectionChanged.emit();
    }
}
